import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/modules/legal/LegalPageLayout.tsx");
